import * as devisConf from '@/configuration/devisConf';
import i18n from '@/i18n';

export default function initializePopUpAvoir(sousType, withLettrageLettre) {
  const messages = {
    title: i18n.t('detail.popup.annulerFacture'),
    avoirMess: i18n.t('detail.popup.avoirMessage'),
    avoirMessFin: i18n.t('detail.popup.finAvoirMessage'),
    confirmAvoir: i18n.t('detail.popup.annulerConfirm'),
    confirmAvoirFin: i18n.t('detail.popup.finAnnulerConfirm'),
  };
  if (sousType === devisConf.SOUS_TYPE_ACOMPTE) {
    messages.title = i18n.t('detail.popup.annulerFactureAcompte');
    messages.avoirMess = i18n.t('detail.popup.avoirAcompteMessage');
    messages.confirmAvoir = i18n.t('detail.popup.annulerAcompteConfirm');
    return messages;
  }
  if (withLettrageLettre) {
    messages.preventAvoirFacturePaye = i18n.t('detail.popup.annulerFacturePayer');
  }
  return messages;
}
